export const TRANSCRIPT_CORRECTIONS_SLICE_NAME = 'transcriptCorrections';
